import React from 'react';
import { useMapStore } from '../store/mapStore';
import { History, Search, Filter, Bookmark, ListCollapse} from 'lucide-react';

const Navbar = () => {
  const isMobile = window.innerWidth <= 800;
  const { setSearchVisible, isSearchVisible, setHomeVisible, isHomeVisible, showFilters, setShowFilters, filtersState, isFavoritesVisible, setFavoritesVisible} = useMapStore();
  const industry = [
    { label: 'Restaurants & Bars', value: 'Restaurants & Bars', icon: 'assets/industries/Restaurants.svg' },
    { label: 'Healthcare', value: 'healthcare', icon: 'assets/industries/Healthcare.svg' },
    { label: 'Retail', value: 'RETAIL OUTLETS-NON-GROCERY', icon: 'assets/industries/Retail.svg' },
    { label: 'Travel & Leisure', value: 'Travel & Leisure', icon: 'assets/industries/Travel.svg' },
    { label: 'Education', value: 'education', icon: 'assets/industries/Education.svg' },
    { label: 'Government', value: 'GOVERNMENT EMPLOYMENT', icon: 'assets/industries/Government.svg' },
    { label: 'Other', value: 'All Other Foodservice', icon: 'assets/industries/Other.svg' },
  ];
  const totalDefaults = {
    acctype: ['lcc', 'oth', 'trs'],
    industry: industry.map(i => i.value),
    cuisine: ['African','American','Americanized Chinese','Authentic Chinese','Bakery','Bar','BBQ','Beverages','Brewery','Burgers','Cafe','Cajun/Creole','Caribbean','Chicken Wings','Desserts','Diner','European','French','German','Hawaiian','Hot Dogs','Indian','Irish','Italian','Japanese','Korean','Med or Mid','Mexican','Other','Other Asian','Pizza','Salad','Sandwich','Seafood','Snacks','South American','Southern/Soulfood','Steak','Sushi','Tacos','Thai','Vietnamese'],
    businessUnit: ['US Broadline', 'Freshpoint', 'SSMG', 'Hawaii', 'Asian Foods', 'European Imports', 'Guest Supply', 'Canada'],
    perks: ['Enrolled', 'notEnrolled'],
    yourWay: ['Enrolled', 'notEnrolled'],
    csScore: ['New','1','2','3','4','5'],
  };
   
  const unselectedCount = Object.entries(totalDefaults).reduce((sum, [key, values]) => {
    const selected = filtersState[key] || [];
    const missing = values.filter(val => !selected.includes(val));
    return sum + missing.length;
  }, 0);
  
  
  if (isMobile) {
    return (
      <div className="fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 z-50 flex justify-around items-center h-[60px]">
        {/* Saved (Favorites) */}
       <button
        className="flex flex-col items-center justify-center flex-1 py-2"
        onClick={() => {
          const { isHomeVisible, isFavoritesVisible} = useMapStore.getState();
          const showingSaved = isHomeVisible && isFavoritesVisible;
          console.log("is showing saved, isHomeVisible, isFavoritesVisible",showingSaved, isHomeVisible, isFavoritesVisible)

          if (showingSaved) {
            // panel is showing Saved → close it
            setHomeVisible(false);
            setFavoritesVisible(false);
            setSearchVisible(false);
          } else {
            // open panel and show Saved (even if Recent was showing)
            setHomeVisible(true);
            setFavoritesVisible(true);
            setSearchVisible(false);
          }
        }}
        aria-label="Saved"
      >
        <Bookmark className="h-5 w-5 text-gray-900" />
        <span className="text-fluid-xs text-gray-900">Bookmarks</span>
      </button>
        {/* //results */}
        <button
          className="flex flex-col items-center justify-center flex-1 py-2"
          onClick={() => {
            const { isHomeVisible, isFavoritesVisible } = useMapStore.getState();
            const showingRecent = isHomeVisible && !isFavoritesVisible;
            console.log("is showing showingRecent, isHomeVisible, isFavoritesVisible",showingRecent, isHomeVisible, isFavoritesVisible)
            if (showingRecent) {
              // panel is showing Recent → close it
              setHomeVisible(false);
              setFavoritesVisible(false);
              setSearchVisible(false);
            } else {
              // open panel and show Recent (hide Saved if it was on)
              setFavoritesVisible(false);
              setHomeVisible(true);
              setSearchVisible(false);
            }
          }}
          aria-label="Recent"
        >
          <History className="h-5 w-5 text-gray-900" />
          <span className="text-fluid-xs text-gray-900">Recent</span>
        </button>

        {/* Search results */}
        <button
          className="flex flex-col items-center justify-center flex-1 py-2"
          onClick={() => {
            setFavoritesVisible(false);
            setHomeVisible(false);
            setSearchVisible(!isSearchVisible);

          }}
          aria-label="Results"
        >
          <Search className="h-5 w-5 text-gray-900" />
          <span className="text-fluid-xs text-gray-900">Results</span>
        </button>


        <button className="flex flex-col items-center justify-center flex-1 py-2"
          onClick={() => {
            setShowFilters(true);
            setFavoritesVisible(false);
            // setHomeVisible(false);
            setSearchVisible(false);
          }}
        >
        
          <Filter className="h-5 w-5 text-gray-900" />
          <span className="text-fluid-xs text-gray-900">Filters</span>

          {unselectedCount > 0 && (
            <span className="absolute top-1 right-7 bg-blue-500 text-white text-fluid-xs px-1 rounded-full">
              {unselectedCount}
            </span>
          )}
          {/* <img 
            src="assets/mobile-assets/filter-icon.svg" 
            alt="Filter" 
            className="w-6 h-6 mb-1"
          /> */}
        </button>

        {/* <button className="flex flex-col items-center justify-center flex-1 py-2">
          <img 
            src="assets/mobile-assets/settings-icon.svg" 
            alt="Settings" 
            className="w-6 h-6 mb-1"
          />
          <span className="text-fluid-xs text-gray-600">Settings</span>
        </button> */}
      </div>
    );
  }

  return (
    <div className="left-sidebar z-40">
      <div className="py-4">
        <img 
          src="assets/header-logo.png" 
          alt="Sales Map Logo" 
          className="w-20 h-auto mx-auto mb-4"
        />
      </div>
    
      
    <button
      className={`left-sidebar-item mt-1 ${useMapStore.getState().controlsOpen ? 'active ring-2 ring-blue-500 ring-offset-2' : ''}`}
      onClick={() => {
        const { toggleControls, controlsOpen } = useMapStore.getState();
        console.log('Navbar: toggle controls (was)', controlsOpen);
        toggleControls();
      }}
      aria-pressed={useMapStore.getState().controlsOpen}
      aria-label="Toggle menu"
      title="Menu"
    >
      <div className={`w-full flex flex-col items-center transition-transform duration-200 ${useMapStore.getState().controlsOpen ? 'scale-105' : 'scale-100'}`}>
        {/* You can keep your icon asset, or use lucide's Filter/Panel icon */}
        <ListCollapse className="w-6 h-6 text-white-600" /> 
        <span>Menu</span>
      </div>
    </button>
    </div>
  );
};

export default Navbar;